export enum ShopifyVariantFieldType {
  Sku = "sku",
  RequiresShipping = "requires_shipping",
  CountryOfOrigin = "country_of_origin",
  HsCode = "hs_code",
  Weight = "weight",
  Barcode = "barcode",
  Price = "price",
  Cost = "cost",
  CompareAtPrice = "compare_at_price",
  DisplayName = "display_name",
  Title = "title",
  Taxable = "taxable",
  InventoryPolicy = "inventory_policy",
  ShowUnitPrice = "show_unit_price",
  UpmMeasuredType = "upm_measured_type",
  UpmQuantityUnit = "upm_quantity_unit",
  UpmQuantityValue = "upm_quantity_value",
  UpmReferenceUnit = "upm_reference_unit",
  UpmReferenceValue = "upm_reference_value",
  Metafield = "metafield",
  InventoryTracked = "inventory_tracked",
}
